import { Chip } from '@mui/material';
import type { UserStatus } from '../types/user.types';

interface UserStatusChipProps {
  status: UserStatus;
}

const statusConfig = {
  active: { label: 'Active', color: 'success' as const },
  suspended: { label: 'Suspended', color: 'error' as const },
};

export function UserStatusChip({ status }: UserStatusChipProps) {
  const config = statusConfig[status];
  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      variant="outlined"
    />
  );
}
